import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import elementsIds from '@/const/elementIds.json';
import { AgentsQuery } from '@/graphql/codegen/generated/graphql';
import { useOsService } from '@/services/OsService/OsService';
import agentsTableLinux from './agent-table-list/OS/agents-table.linux.vue';
import agentsTableWindows from './agent-table-list/OS/agents-table.windows.vue';
import { useAgentsTableConstants } from './agents-table.const';


export default /*#__PURE__*/_defineComponent({
  __name: 'agents-table',
  props: {
    columns: null,
    agentsQueryResult: null
  },
  setup(__props: any) {

const osService = useOsService();


return (_ctx: any,_cache: any) => {
  return (_unref(osService)?.isWindows.value)
    ? (_openBlock(), _createBlock(agentsTableWindows, {
        key: 0,
        "data-testid": _unref(elementsIds).agents.agentsTableList.listWindows,
        columns: __props.columns,
        "agents-query-result": __props.agentsQueryResult
      }, null, 8, ["data-testid", "columns", "agents-query-result"]))
    : (_unref(osService)?.isUnix.value)
      ? (_openBlock(), _createBlock(agentsTableLinux, {
          key: 1,
          "data-testid": _unref(elementsIds).agents.agentsTableList.listLinux,
          columns: __props.columns,
          "agents-query-result": __props.agentsQueryResult
        }, null, 8, ["data-testid", "columns", "agents-query-result"]))
      : _createCommentVNode("", true)
}
}

})